import { tr } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import "../../../styles/app.scss";
import ImageLoading from "../../../components/ImageLoading";
import NoDataFound from "../../../components/NoDataFound";
function DpdInvokeTable({
  setInvokeCount,
  invocationState,
  setTotalPages,
  setTotalRows,
  pageNo,
  rowsPerPage,
  searchValue,
  setEndIndex,
  setSelectArray,
  reRender,
}) {
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [list, setList] = useState([]);
  const [imageLoading, setImageLoading] = useState(true);
  const handleSelectAll = () => {
    setSelectAll((prevSelectAll) => {
      const newValue = !prevSelectAll;
      if (newValue) {
        setSelectedItems(list.map((_, index) => _.order_uuid));
      } else {
        setSelectedItems([]);
      }
      return newValue;
    });
  };
  function replaceUnderscore(str) {
    return str.replace(/_/g, " ");
  }
  const fetchDpd = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/invoke/dpd_orders?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}`,
        options
      );
      setTotalPages(res.data.total_page_count);
      setTotalRows(res.data.total_records);
      setList(res.data.invoke_data);
      setImageLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fetchDpdInitiated = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/invoke/dpd_orders?page=${pageNo}&per_page=${rowsPerPage}&filter_name=${searchValue}&initiate_invoked=true`,
        options
      );
      setTotalPages(res.data.total_page_count);
      setTotalRows(res.data.total_records);
      setList(res.data.invoke_data);
      setImageLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const formatInvokeDate = (date) => {
    return ` ${5 - date} days ago`;
  };
  const handleSelectItem = (index) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedItems = [...prevSelectedItems];
      const itemIndex = updatedItems.indexOf(index);
      if (itemIndex !== -1) {
        updatedItems.splice(itemIndex, 1);
      } else {
        updatedItems.push(index);
      }
      setSelectAll(updatedItems.length === list.length);
      return updatedItems;
    });
  };
  function formatToIndianRupees(num) {
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  function truncateText(text, maxLength) {
    if (text === null) return "---";
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }
  useEffect(() => {
    setSelectArray(selectedItems);
    setInvokeCount(selectedItems.length);
  }, [selectedItems]);

  useEffect(() => {
    const controller = new AbortController();
    setSelectedItems([]);
    setSelectAll(false);
    if (invocationState === "initiatedInvocation") {
      fetchDpdInitiated(controller);
    } else {
      fetchDpd(controller);
    }
    return () => {
      controller.abort();
    };
  }, [pageNo, rowsPerPage, searchValue, invocationState, reRender]);
  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);
  return (
    <div className=" pt-3  w-full bg-white">
      {imageLoading && (
        <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
          <ImageLoading />
        </div>
      )}
      {list.length < 1 && !imageLoading ? (
        <div className="w-full h-[calc(100vh-248px)] flex items-center justify-center">
          <NoDataFound />
        </div>
      ) : (
        <>
          {!imageLoading && (
            <div className=" overflow-auto">
              <table className="w-full box-border h-full flex flex-col min-w-[1160px]">
                <thead className="text-sm font-semibold h-full">
                  <tr className="w-full flex items-center">
                    <th className="text-center pl-6 pr-4 pt-3 pb-2 w-[5%]">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={(e) => handleSelectAll(e)}
                        className="border-2 border-[#00394d] focus:border-[#00394d]"
                      />
                    </th>
                    <th
                      className={`text-left ${
                        invocationState === "initiatedInvocation"
                          ? "w-[11%]"
                          : "w-[14%]"
                      }`}
                    >
                      Name
                    </th>
                    <th
                      className={`text-left pl-4 ${
                        invocationState === "initiatedInvocation"
                          ? "w-[11%]"
                          : "w-[12%]"
                      }`}
                    >
                      Reference No.
                    </th>
                    <th className="text-left  w-[8%]">Distributor</th>
                    <th
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[16%]"
                          : "w-[16%]"
                      }`}
                    >
                      current Pledged assets value(A)
                    </th>
                    <th
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[12%]"
                          : "w-[15%]"
                      }`}
                    >
                      Loan Value(B)
                    </th>
                    <th
                      className={`text-right ${
                        invocationState === "initiatedInvocation"
                          ? "w-[12%]"
                          : "w-[15%]"
                      }`}
                    >
                      Last EMI date
                    </th>
                    {invocationState === "initiatedInvocation" && (
                      <th className=" text-center w-[17%] pl-8">Status</th>
                    )}
                    <th
                      className={`text-right pr-6 ${
                        invocationState === "initiatedInvocation"
                          ? "w-[13%]"
                          : "w-[15%]"
                      }`}
                    >
                      Difference
                    </th>
                  </tr>
                </thead>

                <tbody className="  overflow-auto  max-h-[calc(100vh-285px)]">
                  {list?.map((data, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                      } text-xs font-medium w-full flex items-center ${
                        selectedItems.includes(data.order_uuid) &&
                        "!bg-[#b0c2c8]"
                      }`}
                    >
                      <td className="text-center pl-6 pr-4 pt-3 pb-2 w-[5%]">
                        <input
                          type="checkbox"
                          checked={selectedItems.includes(data.order_uuid)}
                          onChange={() => handleSelectItem(data.order_uuid)}
                        />
                      </td>
                      <td
                        title={data.name?.length > 23 ? data.name : ""}
                        className={`text-left ${
                          invocationState === "initiatedInvocation"
                            ? "w-[11%]"
                            : "w-[14%]"
                        }`}
                      >
                        {truncateText(data.name, 23) || "---"}
                      </td>
                      <td
                        className={`text-left pl-4 ${
                          invocationState === "initiatedInvocation"
                            ? "w-[11%]"
                            : "w-[12%]"
                        }`}
                      >
                        <Link
                          to={`../individuals/${data.user_uuid}?name=${data.name}`}
                        >
                          {data.reference_no}{" "}
                        </Link>
                      </td>
                      <td className="text-left  w-[8%]">
                        {truncateText(data.distributor_name, 15)}
                      </td>
                      <td
                        className={`text-right ${
                          invocationState === "initiatedInvocation"
                            ? "w-[16%]"
                            : "w-[16%]"
                        }`}
                      >
                        {formatToIndianRupees(data.current_market_price)}
                      </td>
                      <td
                        className={`text-right ${
                          invocationState === "initiatedInvocation"
                            ? "w-[12%]"
                            : "w-[15%]"
                        }`}
                      >
                        {formatToIndianRupees(data.loan_value)}
                      </td>
                      <td
                        className={`text-right ${
                          invocationState === "initiatedInvocation"
                            ? "w-[12%]"
                            : "w-[15%]"
                        }`}
                      >
                        {data?.emi_date || "---"}
                      </td>
                      {invocationState === "initiatedInvocation" && (
                        <td className="text-center w-[17%] pl-8 text-[10px]">
                          <span className=" py-1 px-2 bg-[#DBE8DB] rounded-xl text-[#0BA300] mr-2">
                            {replaceUnderscore(data.status)}{" "}
                          </span>
                          <span className=" text-[#262626]">
                            {formatInvokeDate(data.invoke_date)}
                          </span>
                        </td>
                      )}
                      <td
                        className={`text-right pr-6 text-[#0ba300]  ${
                          invocationState === "initiatedInvocation"
                            ? "w-[13%]"
                            : "w-[15%]"
                        }`}
                      >
                        {formatToIndianRupees(data.difference)} (
                        {data.percentage}
                        %)
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default DpdInvokeTable;
